<template>
  <div class="container h-100">
    <div class="row h-100">
        <div class="col-6 mx-auto my-auto">
          <div class="card card-block">
            <article class="card-body">
              <h4 class="card-title text-center mb-4 mt-1">OZiVu</h4>
              <hr>
              <p class="text-success text-center">Seulement pour les administrateurs</p>
              <form @submit.prevent="login">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> <i class="icon-user"></i> </span>
                    </div>
                    <input v-model="username" class="form-control" placeholder="nom d'usager">
                  </div> <!-- input-group.// -->
                </div> <!-- form-group// -->
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> <i class="icon-lock"></i> </span>
                    </div>
                    <input v-model="password" class="form-control" placeholder="******" type="password">
                  </div> <!-- input-group.// -->
                </div> <!-- form-group// -->
                <div class="form-group">
                  <button type="submit" class="btn btn-primary btn-block"> Login  </button>
                </div> <!-- form-group// -->
              </form>
              <p v-if="error" class="text-danger text-center">
                <small>Nom d'usager ou mot de passe invalide</small>
              </p>
            </article>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Login',
  data: function() {return {
    username: "",
    password: "",
    respData: {},
    error: null
  }},
  methods: {
   login: function () {
     const { username, password } = this;
     // console.log("Login...")

     axios({url: this.$root.$data.server_base + '/api/auth.php',
        data: {username: username, password: password}, method: 'POST' })
     .then(resp => {
        if(resp.data.error) {
          localStorage.removeItem('jwt');
          this.error=true;
        } else {
          // Add to all subsequent queries
          const token = resp.data.token;
          axios.defaults.headers.common['X-Custom-Authorization'] = token;
          localStorage.jwt = token;

          this.$root.$data.firstName=resp.data.firstName;
          localStorage.firstName = resp.data.firstName;
          this.$router.push('/tableaudebord')
        }
     }).catch(() => {
       localStorage.removeItem('jwt');
       this.error=true;
     })
   }
  }
}
</script>
